/**
 * Bob Manager — shared MODEL dropdown options.
 *
 * Renders the model list with OpenRouter models pushed into their own
 * "OpenRouter" <optgroup> at the BOTTOM. OpenRouter exposes hundreds of models,
 * so keeping them in one section at the end makes the other (local + other API)
 * models easy to find. Used by the labs and agents model selectors.
 *
 * Usage (inside a <select>, after the placeholder <option>):
 *   <ModelOptions models={allModels} />                 // available-only (labs)
 *   <ModelOptions models={allModels} includeOffline />  // include offline w/ suffix (agents)
 */

import React from 'react';

// Provider types whose models are grouped into their own bottom section.
export const BOTTOM_SECTION_TYPE = 'openrouter';

export function ModelOptions({ models = [], includeOffline = false }) {
  const list = includeOffline ? models : models.filter(m => m.is_available);
  const rest = list.filter(m => m.provider_type !== BOTTOM_SECTION_TYPE);
  const openrouter = list.filter(m => m.provider_type === BOTTOM_SECTION_TYPE);

  const renderOption = (m) => (
    <option key={m.id} value={m.id}>
      {m.model_identifier}{includeOffline && m.is_available === false ? ' (offline)' : ''}
    </option>
  );

  return (
    <>
      {rest.map(renderOption)}
      {openrouter.length > 0 && (
        <optgroup label="OpenRouter">{openrouter.map(renderOption)}</optgroup>
      )}
    </>
  );
}

export default ModelOptions;
